import { getEditableField } from '../store/selectors';
import { t } from '../../../../infra/i18n';
export var validateSchedule = function (params) {
    var state = params.store.getState();
    var isValid = true;
    var errors = [];
    var usesCustomScheduleField = getEditableField(state, 'usesCustomSchedule');
    if (usesCustomScheduleField.value) {
        var frequencyField = getEditableField(state, 'frequency');
        var sendTimeField = getEditableField(state, 'sendTime');
        var sendDateField = getEditableField(state, 'sendDate');
        var endDateField = getEditableField(state, 'endDate');
        var dayOfWeekField = getEditableField(state, 'dayOfWeek');
        var dayOfMonthField = getEditableField(state, 'dayOfMonth');
        var frequency = frequencyField.value;
        if (!frequency) {
            isValid = false;
            errors.push({
                field: 'frequency',
                message: t('engage:validation.select_frequency'),
            });
        }
        if (!sendTimeField.value) {
            isValid = false;
            errors.push({
                field: 'sendTime',
                message: t('engage:validation.select_time'),
            });
        }
        if (frequency === 'one-time' && !sendDateField.value) {
            isValid = false;
            errors.push({
                field: 'sendDate',
                message: t('engage:validation.select_date'),
            });
        }
        if (frequency !== 'one-time' && endDateField.value) {
            var now = new Date();
            var endDate = new Date(endDateField.value);
            if (endDate <= now) {
                isValid = false;
                errors.push({
                    field: 'endDate',
                    message: t('engage:validation.end_date_future'),
                });
            }
        }
        if (frequency === 'weekly' || frequency === 'bi-weekly') {
            if (!dayOfWeekField.value) {
                isValid = false;
                errors.push({
                    field: 'dayOfWeek',
                    message: t('engage:validation.select_day_of_week'),
                });
            }
        }
        if (frequency === 'monthly') {
            if (!dayOfMonthField.value) {
                isValid = false;
                errors.push({
                    field: 'dayOfMonth',
                    message: t('engage:validation.select_day_of_month'),
                });
            }
            else {
                var day = parseInt(dayOfMonthField.value, 10);
                if (Number.isNaN(day) || day < 1 || day > 31) {
                    isValid = false;
                    errors.push({
                        field: 'dayOfMonth',
                        message: t('engage:validation.select_valid_day_of_month'),
                    });
                }
            }
        }
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
